import { render, staticRenderFns } from "./WebPhoneDialer.vue?vue&type=template&id=3af95024&scoped=true"
import script from "./WebPhoneDialer.vue?vue&type=script&lang=js"
export * from "./WebPhoneDialer.vue?vue&type=script&lang=js"
import style0 from "./WebPhoneDialer.vue?vue&type=style&index=0&id=3af95024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af95024",
  null
  
)

export default component.exports